import { useMemo } from "react";
import BarChart from "../../../components/Charts/BarChart";
import SectionCard from "../../../components/SectionCard";
import { transformGroupedBarChartData } from "../../../utils/hdbDashboardUtils";
import { useDashboard } from "../../../context/HDBDashboardContext";
import styles from "./index.module.scss";

const Demographics = ({ section }) => {
  const { updateFilters } = useDashboard();

  const { labels: xLabels, datasets } = useMemo(
    () => transformGroupedBarChartData(section),
    [section],
  );
  
  const handleBarClick = ({ filterInfo }) => {
    if (filterInfo) {
      updateFilters(filterInfo);
    }
  };

  return (
     <SectionCard title={section?.displayName}>
    {section?.count ? (
      <BarChart
        labels={xLabels}
        datasets={datasets}
        colors={["#2F73F1", "#FF60A5"]}
        stacked={true}
        showLegend={true}
        onBarClick={handleBarClick}
      />
    ) : (
      <div className={styles.noData}>
        No Data
      </div>
    )}
  </SectionCard>
   
  );
};

export default Demographics;